export default __webpack_public_path__ + "static/media/hfp4.25ce1333.jpg";